(() => {
  const mediaSelector = [
    'img',
    'picture',
    'video',
    'svg',
    'canvas',
    'model-viewer',
    'iframe[src*="youtube"]',
    'iframe[src*="vimeo"]',
    '[data-vanta-media-protected]',
  ].join(',');

  const interactiveSelector = [
    'button',
    'a',
    'input',
    'select',
    'textarea',
    'summary',
    '[role="button"]',
    '[tabindex]',
    '.vanta-product-gallery-arrow',
    '.slider-button',
  ].join(',');

  const hasProtectedBackground = (element) => {
    if (!(element instanceof HTMLElement)) return false;

    const backgroundImage = window.getComputedStyle(element).backgroundImage;
    return backgroundImage && backgroundImage !== 'none';
  };

  const getProtectedMediaTarget = (target) => {
    if (!(target instanceof Element)) return null;

    const mediaElement = target.closest(mediaSelector);
    if (mediaElement) return mediaElement;

    const backgroundElement = target.closest('[data-vanta-media-protected]') || target.closest('section, div, li, a');
    return hasProtectedBackground(backgroundElement) ? backgroundElement : null;
  };

  const protectMediaElements = (root = document) => {
    const mediaElements = root.matches?.(mediaSelector)
      ? [root]
      : Array.from(root.querySelectorAll?.(mediaSelector) || []);

    mediaElements.forEach((element) => {
      element.setAttribute('draggable', 'false');
      element.classList.add('vanta-media-protected');
    });
  };

  const blockMediaEvent = (event) => {
    const protectedTarget = getProtectedMediaTarget(event.target);
    if (!protectedTarget) return;

    if (event.type === 'mousedown' && event.target.closest(interactiveSelector)) return;

    event.preventDefault();
  };

  const blockMediaKeyboardShortcut = (event) => {
    if (!(event.metaKey || event.ctrlKey)) return;
    if (!['c', 'x', 's', 'u'].includes(event.key.toLowerCase())) return;
    if (!getProtectedMediaTarget(document.activeElement)) return;

    event.preventDefault();
  };

  if (!document.body) return;

  protectMediaElements();

  ['contextmenu', 'copy', 'cut', 'dragstart'].forEach((eventName) => {
    document.addEventListener(eventName, blockMediaEvent, true);
  });

  document.addEventListener('keydown', blockMediaKeyboardShortcut, true);

  const pendingMediaRoots = new Set();
  let mediaProtectionFrame = null;

  const scheduleMediaProtection = (root) => {
    if (!(root instanceof Element)) return;

    pendingMediaRoots.add(root);
    if (mediaProtectionFrame) return;

    mediaProtectionFrame = window.requestAnimationFrame(() => {
      mediaProtectionFrame = null;
      const roots = Array.from(pendingMediaRoots);
      pendingMediaRoots.clear();
      roots.forEach((pendingRoot) => protectMediaElements(pendingRoot));
    });
  };

  new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType !== Node.ELEMENT_NODE) return;
        scheduleMediaProtection(node);
      });
    });
  }).observe(document.body, { childList: true, subtree: true });
})();
